import { ConsumptionModeType } from '@innovorder/order_detail';
import { RoutesPath } from 'core/routes.types';
import { useCustomNavigate } from 'hooks/useCustomNavigate';
import { useEffect } from 'react';
import { generatePath, useParams } from 'react-router-dom';
import { convertModeToUrl } from 'utils/consumptionModes';

const sitInMode = convertModeToUrl(ConsumptionModeType.MODE_SIT_IN);

const RedirectToNewUrl = ({ newUrl }: { newUrl: RoutesPath }) => {
    const { navigateWithParams } = useCustomNavigate();
    const { restaurantId } = useParams();

    useEffect(() => {
        if (newUrl === RoutesPath.MenuHome && restaurantId)
            navigateWithParams(
                `../${generatePath(RoutesPath.MenuHome, { restaurantId, mode: sitInMode })}`,
            );
        if (newUrl === RoutesPath.Restaurants)
            navigateWithParams(`../${generatePath(RoutesPath.Restaurants, { mode: sitInMode })}`);
    }, [navigateWithParams, restaurantId, newUrl]);
    return <></>;
};

export default RedirectToNewUrl;
